// All routes start with their final fonts, including direct article links.
// On failure, keep one fallback for this visit instead of swapping it later.
export async function prepareFonts() {
    if (!document.fonts?.load) return;
    let timer;
    try {
        await Promise.race([
            Promise.all([
                '300 36px "Neue Montreal"', '500 16px "Neue Montreal"',
                '400 16px "Hanken Grotesk"', '500 16px "Hanken Grotesk"',
                '600 16px "Hanken Grotesk"', '700 16px "Hanken Grotesk"',
                'italic 400 16px "Hanken Grotesk"',
            ].map(font => document.fonts.load(font).then(faces => {
                if (!faces.length) throw new Error('Font unavailable');
            }))),
            new Promise((_, reject) => { timer = setTimeout(() => reject(new Error('Font timeout')), 4000); }),
        ]);
    } catch {
        document.documentElement.classList.add('font-fallback');
    } finally {
        clearTimeout(timer);
    }
}
